import Toggle from '../modules/Toggle'
import { CssModifiers, PubSub, ExcessiveEvents, FeatureDetection } from '../utils/'

let $searchBar = undefined
let $handle = undefined
let $clear = undefined
let $input = undefined

let toggle = undefined
let hasInPageSearch = true
let headerBarIsOpen = false


/**
 * Initialises the modules
 */
const init = () => {
  const $headerSearchBar = document.querySelector(`#PsHeaderSearchBar`)
  const $inPageSearchBar = document.querySelector(`#PsInPageSearchBar`)

  $handle = document.querySelector(`#PsSearchBarHandle`)

  hasInPageSearch = $inPageSearchBar != null
  // Assert which search bar should be interacted with
  $searchBar = hasInPageSearch ? $inPageSearchBar : $headerSearchBar

  if ($searchBar == null || $handle == null) return

  $input = $searchBar.querySelector('input')

  if (hasInPageSearch == false) {
    // We only want to toggle the header search bar if the in-page search bar is not present
    toggle = new Toggle($handle, { contentId: $searchBar.id, modifier: 'm-active' })
    toggle.init()
  } else {
    $clear = $searchBar.querySelector(`.ps-search-icon[m-active]`)
  }

  addEventListeners()
}


/**
 * Function called when toggle custom event is published
 * @param {Object} data - object passed in from pubsub publish
 */
const respondToToggle = data => {
  $input.value = ''
  // Check that the toggle element trigger was from the header search handle
  if (data.element.id == $handle.id) {
    setHeaderBarStatus(data.isOpen)

    // Set the opacity of the main header to 100% to ensure text is not obscured
    data.isOpen
      ? PubSub.publish('header:active')
      : PubSub.publish('header:scroll')
  }
}


/**
 * Sets the 'visibility' status of the header search bar
 * @param {Boolean} isOpen
 */
const setHeaderBarStatus = isOpen => headerBarIsOpen = isOpen


/**
 * Sets the input focus and scrolls to the in page search bar if it's present
 */
const focusInput = () => {
  $input.focus()
  // If we're focusing on the in page search, we need to scroll it into view
  window.scrollTo(0, 0)
}


/**
 * Adds a focus state modifier to the search bar container for aestetic value
 * @param {Boolean} isFocused
 */
const setSearchBarFocus = isFocused => {
  CssModifiers.toggle($searchBar, isFocused, 'm-focused')
}


/**
 * clears the search bar value
 */
const clearSearch = () => {
  $input.value = ''
  focusInput()
}


/**
 * Closes the header search bar
 */
const closeHeaderSearch = () => {
  if (headerBarIsOpen == false) return
  setHeaderBarStatus(false)

  $input.blur()
  $input.value = ''
  toggle.options.isOpen = false
  toggle.toggle()
}


/**
 * Hides the header search bar when the user scrolls
 */
const onScroll = () => {
  if (hasInPageSearch || headerBarIsOpen == false) return
  if (headerBarIsOpen) PubSub.publish('header:active')
  if (headerBarIsOpen && document.activeElement.getAttribute('name') != $input.getAttribute('name')) {
    closeHeaderSearch()
  }
}


/**
 * Hides the header search bar if the user scrolls whilst the search is active
 */
const onTouchMove = () => {

  if (hasInPageSearch || headerBarIsOpen == false) return

  if (headerBarIsOpen && document.activeElement.getAttribute('name') == $input.getAttribute('name')) {
    closeHeaderSearch()
  }
}


/**
 * Bind DOM Event handlers
 */
const addEventListeners = () => {
  PubSub.subscribe('toggle:open', respondToToggle)
  PubSub.subscribe('toggle:close', respondToToggle)
  PubSub.subscribe(`mainnav:open`, closeHeaderSearch)

  if (hasInPageSearch) {
    $clear.addEventListener('click', clearSearch)
    $handle.addEventListener('click', focusInput)
    window.addEventListener('hashchange', focusInput)
  }

  if (FeatureDetection.os.isIOS()) window.addEventListener('touchmove', onTouchMove)

  $input.addEventListener('focus', setSearchBarFocus.bind(null, true))
  $input.addEventListener('blur', setSearchBarFocus.bind(null, false))

  window.addEventListener('scroll', ExcessiveEvents.debounce(onScroll, 300))
}

const SearchBar = { init }
export default SearchBar



// WEBPACK FOOTER //
// ./js/core/SearchBar.js